<template>
  <div v-if="items.length" class="space-y-4">
    <div class="flex items-center justify-between pt-3">
      <h4 class="font-medium text-sm text-slate-700">
        Wybrane zdjęcia ({{ items.length }})
      </h4>
      <button
        type="button"
        class="flex items-center gap-2 px-3 py-1.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors text-sm font-medium"
        @click="handleRemoveAll"
      >
        <font-awesome-icon icon="trash" class="text-xs" />
        Usuń wszystkie
      </button>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <ImagePreviewItem
        v-for="(item, idx) in items"
        :key="item.key"
        :image-url="item.previewUrl"
        :is-cover="idx === 0"
        :show-remove-button="!!item.file"
        :is-dragging="draggingIndex === idx"
        :is-drop-target="dragOverIndex === idx"
        @drag-start="handleDragStart(idx, $event)"
        @drag-over="handleDragOver(idx)"
        @drop="handleDrop(idx)"
        @drag-end="handleDragEnd"
        @remove="handleRemove(idx)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ImagePreviewItem from './ImagePreviewItem.vue';
import type { ImageItem } from '../modules/offers/types/image.types';

defineProps<{
  items: ImageItem[];
  draggingIndex: number | null;
  dragOverIndex: number | null;
}>();

const emit = defineEmits<{
  dragStart: [index: number, event: DragEvent];
  dragOver: [index: number];
  drop: [index: number];
  dragEnd: [];
  remove: [index: number];
  removeAll: [];
}>();

function handleDragStart(index: number, event: DragEvent) {
  emit('dragStart', index, event);
}

function handleDragOver(index: number) {
  emit('dragOver', index);
}

function handleDrop(index: number) {
  emit('drop', index);
}

function handleDragEnd() {
  emit('dragEnd');
}

function handleRemove(index: number) {
  emit('remove', index);
}

function handleRemoveAll() {
  emit('removeAll');
}
</script>